import React from "react";
import PropTypes from "prop-types";

const ErrorMessage = ({ error }) => {
    return (
        <>
            {error && (
                <small className="w-100 text-danger">
                    {typeof error === "object" ? error.value : error}
                </small>
            )}
        </>
    );
};

ErrorMessage.propTypes = {
    error: PropTypes.string
};
export default ErrorMessage;
